<template>
  <div class="boxLocaleOccurrence mb-4"
       :class="{'boxLocaleOccurrence_error': propCorrecoes['LOCAL DE OCORRÊNCIA']}">
    <header class="boxLocaleOccurrence_header p-2">
      <h3 class="boxLocaleOccurrence_header_title">
        {{ dados.descricao || tipo | firstCapitalize }}
      </h3>
    </header>
    <div class="boxLocaleOccurrence_body py-2 px-3">
      <div class="row no-gutters align-items-center justify-content-between">
        <div class="d-inline-flex align-items-center">
          <ul class="boxLocaleOccurrence_list d-inline-block mr-5">
            <li class="boxLocaleOccurrence_list_title">
              Tipo de estabelecimento
            </li>

            <li class="boxLocaleOccurrence_list_item text-capitalize">
              <strong>{{ tipo }}</strong>
            </li>
          </ul>

          <ul v-if="tipo != 'Ignorado'"
              class="boxLocaleOccurrence_list d-inline-block mr-5">
            <li class="boxLocaleOccurrence_list_title">
              Endereço cadastrado
            </li>

            <li class="boxLocaleOccurrence_list_item text-capitalize">
              <strong>{{ dados.endereco | Endereco }}</strong>
            </li>
          </ul>
        </div>

        <div class="d-inline-block">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "BoxLocalOcorrencia",
    props: {
      dados: Object,
      propCorrecoes: {type: Object, default: () => ({})}
    },
    computed: {
      tipo () {
        if ((this.dados.tipo == 'UNIDADE_SAUDE') && this.dados.hospital || this.dados.hospital_id) {
          return 'Hospital'
        }

        if (this.dados.tipo == 'UNIDADE_SAUDE' && !this.dados.hospital) {
          return 'Outros estabelecimentos de saúde'
        }

        if (this.dados.tipo == 'FORA_UNIDADE_SAUDE') {
          return this.dados.sub_tipo == 'domicilio' ? 'Domicílio' : 'Outros'
        }

        switch (this.dados.tipo) {
        case 'VIA_PUBLICA':
          return 'Via pública'
          
        case 'DOMICILIO':
          return 'Domicílio'

        case 'HOSPITAL':
          return 'Hospital'

        case 'AMBULANCIA':
          return 'Ambulância'

        case 'POSTO_SAUDE':
          return 'Posto de Saúde'

        case 'SAMU':
          return 'Samu'

        case 'OUTROS_SERVICOS_SAUDE':
          return 'Outros serviços de saúde'

        case 'OUTRO':
          return 'Outro'

        default:
          return 'Ignorado'
        }
      }
    }
  }
</script>

<style lang="scss">
  @import '/../../../scss/_utilities/_exports';

  .boxLocaleOccurrence {
    box-shadow: 0 0 pxToRem(4) 0 $color-dark;

    &_error {
      border: solid 2px #8B0000;
    }

    &_header {
      background-color: #01AEC9;
      color: $color-dark;

      &_title {
        font-size: pxToRem(14);
        font-weight: 500;
      }
    }

    &_body {
      &_content {}
    }

    &_list {
      font-size: pxToRem(14);
      list-style: none;
      margin: 0;
      padding: 0;

      &_item {}

      &_title {
        margin-bottom: pxToRem(4);
        text-decoration: underline;
      }
    }
  }
</style>
